"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIB_NAME = exports.LIB_VERSION = void 0;
/** DO NOT EDIT: This file is automatically generated by ../scripts/info.js */
exports.LIB_VERSION = '3.2.13';
exports.LIB_NAME = '@clerk/clerk-react';
//# sourceMappingURL=info.js.map